var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('e-tooltip',{attrs:{"content":_vm.tooltip}},[_c('e-icon',{staticClass:"e-margin-right-xs",attrs:{"color":_vm.color,"icon":"exclamation-circle","type":"small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }